<p [class]="isLogin ? 'login-page' : ''">
  <span class="text-gray-800"
    >© 2020-{{ date | date: "yyyy" }} Measured All Rights Reserved</span
  ><span
    ><span> | </span
    ><a routerLink="/terms" class="text-blue-600">Terms of Service</a></span
  ><span class="text-xs text-gray-600 opacity-70"
    ><span> | </span>v{{ clientVersion }}</span
  >
</p>
